import client from './client';

export const createAiConsent = accepted => client({
	method: 'post',
	url: '/telemedicine/ai-consent',
	data: { accepted }
});
